import {
  Users,
  BookOpen,
  ArrowLeft,
  ArrowRight,
  Mail,
  IdCard,
  Lock,
  User,
  EyeOff,
  Eye,
  Menu,
  Factory,
  ListTodo,
  Moon,
  LogOut,
  X,
  ChevronRight,
  ClipboardList,
  ChevronUp,
  ChevronDown,
  Image,
  Search,
  Check,
  Upload,
  Camera,
  MenuSquare,
  Info,
  CircleCheck,
  CircleX,
  TriangleAlert,
  Sun,
  LayoutDashboard,
  Workflow,
  List,
  ListOrdered,
  AlignLeft,
  AlignRight,
  AlignCenter,
  Link,
  Star,
  MessageCircle,
  Heart,
  Send,
  Share2,
  Download,
  LogIn,
  Phone,
  MessageCircleCode,
  Pickaxe,
  Hammer,
  FlaskConical,
  Cog,
  TrendingUp,
  Globe,
  Blocks,
  Droplets,
  ChevronLeft,
  EllipsisVertical,
  Ellipsis,
  Plus,
  RefreshCw,
  TrendingDown,
  Home,
  Bell,
  Clock,
  MonitorCog,
  CircleAlert,
  LoaderCircle,
  Filter,
  Package2,
  BoxIcon,
  Wrench,
  Copy,
  MapPin,
  ClipboardCheck,
  ListTree,
  Group,
  Megaphone,
  Calendar,
  CalendarClock,
  Quote,
  PackageCheck,
  Truck,
  Settings2,
  Puzzle,
  Building2,
  Zap,
  MonitorPlay,
  HardHat,
  Cylinder,
  CircleDot,
  ShowerHead,
  Trash,
  HelpCircle,
  Hand,
  Pencil,
  Grid3x3,
  GraduationCap,
  Folder,
  Folders,
  LayoutGrid,
  MessageSquareText,
  SquareCheck,
  PackageOpen,
  CircleUser,
  RotateCcw,
  RotateCw,
  ZoomIn,
  ZoomOut,
  Maximize2,
  Minimize2,
  Play,
  Pause,
  Volume2,
  Volume1,
  VolumeX,
  FileText,
} from 'lucide-vue-next';

export const iconMap = {
  brochure: BookOpen,
  clipboard: ClipboardList,
  invertedCommas: Quote,

  global: Globe,
  blocks: Blocks,
  drop: Droplets,
  upload: Upload,
  menu: Menu,
  menu_open: MenuSquare,

  delete: Trash,

  shovel: Pickaxe,
  hammer: Hammer,
  flask: FlaskConical,

  package: PackageCheck,
  truck: Truck,
  settings2: Settings2,
  puzzle: Puzzle,
  building: Building2,
  flash: Zap,
  monitor: MonitorPlay,
  preparation: HardHat,

  cylinder: Cylinder,
  circleDot: CircleDot,
  showerHead: ShowerHead,

  moon: Moon,
  login: LogIn,

  phone: Phone,
  whatsapp: MessageCircleCode,

  likes: Heart,
  comments: MessageCircle,

  // Alignment
  list: List,
  orderedList: ListOrdered,
  alignLeft: AlignLeft,
  alignRight: AlignRight,
  alignCenter: AlignCenter,

  star: Star,

  // Status / Feedback
  check_circle: CircleCheck,
  error: CircleX,
  warning: TriangleAlert,
  info: Info,
  light_mode: Sun,
  dark_mode: Moon,

  // Navigation
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  chevron_up: ChevronUp,
  chevron_down: ChevronDown,
  chevronRight: ChevronRight,
  chevron_left: ChevronLeft,
  more_vert: EllipsisVertical,
  more_horiz: Ellipsis,

  // Actions
  add: Plus,
  check: Check,
  cancel: X,
  logout: LogOut,
  switchApps: Grid3x3,
  search: Search,
  refresh: RefreshCw,
  link: Link,
  visibility: Eye,
  question: HelpCircle,

  // Trends
  trending_up: TrendingUp,
  trending_down: TrendingDown,
  trending_flat: TrendingUp, // Lucide has no flat trend; rotated via CSS below

  // Media
  calendar_today: Calendar,
  schedule: CalendarClock,
  camera: Camera,
  image: Image,
  rotateCcw: RotateCcw,
  rotateCw: RotateCw,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  maximize: Maximize2,
  minimize: Minimize2,
  play: Play,
  pause: Pause,
  volumeHigh: Volume2,
  volumeLow: Volume1,
  volumeMute: VolumeX,
  fileText: FileText,

  // Domain
  dashboard: LayoutDashboard,
  layoutGrid: LayoutGrid,
  home: Home,
  settings: Cog,
  notifications: Bell,
  history: Clock,
  monitoring: MonitorCog,
  series: Workflow,
  precision_manufacturing: Factory,
  folder: Folder,
  folders: Folders,
  documents: Folder,
  favorite: Heart,
  inbox: CircleAlert,
  progress_activity: LoaderCircle,
  filter: Filter,
  inventory_2: Package2,
  packageOpen: PackageOpen,
  category: BoxIcon,
  messageSquare: MessageSquareText,
  squareCheck: SquareCheck,

  // People & Places
  person: User,
  personCircle: CircleUser,
  wave: Hand,
  location_on: MapPin,

  // Tools & Actions
  build: Wrench,
  content_copy: Copy,
  checklist: ClipboardCheck,
  tree: ListTree,
  group: Group,
  users: Users,
  campaign: Megaphone,
  send: Send,
  share: Share2,
  download: Download,
  pencil: Pencil,

  potentialLogin: Mail,
  staffLogin: IdCard,
  password: Lock,
  hiddenPass: EyeOff,
  showPass: Eye,

  machines: Factory,
  todo: ListTodo,
  cap: GraduationCap,
} as const;

export type IconName = keyof typeof iconMap;

export type IconSize = 'sm' | 'md' | 'lg' | 'xl';
